import { Heart, HandHeart, Sparkles, Handshake } from "lucide-react";

export const REACTIONS = {
  heart: { icon: Heart, label: "Amor", color: "text-rose-400" },
  clap: { icon: Sparkles, label: "Palmas", color: "text-amber-300" },
  unity: { icon: Handshake, label: "União", color: "text-emerald-400" },
  pray: { icon: HandHeart, label: "Oração", color: "text-indigo-300" },
};

export function ReactionBar({ onReact }) {
  return (
    <div className="flex gap-2" data-testid="reaction-bar">
      {Object.entries(REACTIONS).map(([k, r]) => (
        <button key={k} onClick={() => onReact(k)} title={r.label} data-testid={`reaction-${k}`}
          className="grid h-11 w-11 place-items-center rounded-full bg-black/50 ring-1 ring-white/10 backdrop-blur transition-transform hover:scale-110 active:scale-90">
          <r.icon size={19} className={r.color} />
        </button>
      ))}
    </div>
  );
}

export function FloatingReactions({ items }) {
  return (
    <div className="pointer-events-none absolute bottom-16 right-4 h-72 w-24" data-testid="floating-reactions">
      {items.map((it) => {
        const R = REACTIONS[it.kind];
        return (
          <span key={it.id} className="float-up absolute bottom-0" style={{ left: `${it.left}%` }}>
            <R.icon size={26} className={`${R.color} drop-shadow-lg`} fill="currentColor" />
          </span>
        );
      })}
    </div>
  );
}
